import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ElencoOrdini from './pages/ElencoOrdini/ElencoOrdini';
import DettaglioOrdine from './pages/DettaglioOrdine/DettaglioOrdine';
import Login from './pages/login/Login';
import { AuthProvider } from './contexts/AuthProvider';
import PrivateRoute from './routes/PrivateRoute';
import Layout from './components/layout/Layout.jsx'; // assicurati che il path sia corretto
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Login visibile senza layout */}
          <Route path="/" element={<Login />} />

          {/* Rotte protette con layout */}
          <Route
            path="/ElencoOrdini"
            element={
              <PrivateRoute>
                <Layout>
                  <ElencoOrdini />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/dettaglioOrdine/:idordine"
            element={
              <PrivateRoute>
                <Layout>
                  <DettaglioOrdine />
                </Layout>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
